module.exports = __webpack_public_path__ + "static/media/LinkedIn.0495edc9.svg";